import React, { useRef } from 'react';
import { Modal, ModalTrigger, ModalContent, ModalCloseBtn, ModalHeader } from '@fiverr-private/overlay';
import { PlayOutlineSolidIcon } from '@fiverr-private/icons';
import { theme } from '@fiverr-private/theme';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Video, useVideoBigQueryEvents, useVideoMixpanelEvents } from '@fiverr-private/media';
import { sendMixpanelTrackEvent } from '../../../../lib/mixpanel';
import { INTRO_VIDEO_LINK_CLICK } from '../../../../lib/mixpanel/constants';
import { source, BIMeta } from './constants';

export const VideoButton = () => {
    const videoRef = useRef(null);

    const handleClick = () => {
        sendMixpanelTrackEvent({ eventName: INTRO_VIDEO_LINK_CLICK });
    };

    useVideoBigQueryEvents(videoRef, BIMeta.bigQuery);
    useVideoMixpanelEvents(videoRef, BIMeta.mixpanel);

    return (
        <Modal centered>
            <ModalTrigger>
                <Button variant="ghost" onClick={handleClick} colorScheme="blue">
                    <PlayOutlineSolidIcon size={16} color={theme.colors.blue_700} />
                    <I18n k="tag_page_perseus.header.how_fiverr_works" />
                </Button>
            </ModalTrigger>
            <ModalContent>
                <ModalHeader>
                    <ModalCloseBtn />
                </ModalHeader>
                <Video ref={videoRef} controls source={source} />
            </ModalContent>
        </Modal>
    );
};
